import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
}

export const SEOHead = ({ 
  title = "Gravação de URA Humanizada | Gravação de URA Online",
  description = "Gravação de URA Humanizada com voz profissional. Atendimento telefônico natural que conquista clientes. Orçamento grátis!"
}: SEOHeadProps = {}) => {
  useEffect(() => {
    // Set document title and meta description
    document.title = title;
    
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Add JSON-LD structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "URA Humanizada - Locutora Ellen",
      "description": "Gravação de URA Humanizada profissional para empresas. Atendimento telefônico com voz natural e humanizada que conquista clientes.",
      "url": "https://urahumanizada.com.br",
      "telephone": "+55-11-91045-6805",
      "priceRange": "$$",
      "image": "https://urahumanizada.com.br/og-image.jpg",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "BR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "addressCountry": "BR"
      },
      "sameAs": [
        "https://api.whatsapp.com/send?phone=5511910456805"
      ],
      "serviceType": [
        "Gravação de URA",
        "URA Humanizada",
        "Locução Profissional",
        "Atendimento Telefônico",
        "Mensagens em Espera",
        "URA Multilíngue"
      ],
      "areaServed": {
        "@type": "Country",
        "name": "Brasil"
      },
      "provider": {
        "@type": "Person",
        "name": "Ellen",
        "jobTitle": "Locutora Profissional",
        "description": "Locutora especializada em URA Humanizada e atendimento telefônico profissional"
      },
      "offers": {
        "@type": "Offer",
        "description": "Gravação de URA Humanizada com voz profissional para empresas de todos os segmentos",
        "availability": "https://schema.org/InStock"
      }
    });
    document.head.appendChild(script);

    // Add breadcrumb structured data
    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://urahumanizada.com.br"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Gravação de URA",
          "item": "https://urahumanizada.com.br#portfolio"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Sobre Ellen",
          "item": "https://urahumanizada.com.br#about-ellen"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Contato",
          "item": "https://urahumanizada.com.br#contact"
        }
      ]
    });
    document.head.appendChild(breadcrumbScript);

    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (breadcrumbScript.parentNode) document.head.removeChild(breadcrumbScript);
    };
  }, [title, description]);

  return null;
};
